import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ToolTip from "../../../parts/tooltip";
import SvgIcon from "../../../parts/SvgIcon";
import submit from "submit-form";
import ConfirmationModal from "../../../parts/modals/ConfirmationModal";
import { getComplexName } from "../../../utils/complex";

const ComplexLibraryLine = ({ complex }) => {
  const { t } = useTranslation("coaching-portal");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleDelete = () => {
    setIsModalOpen(false);
    submit(`/actions/complex/delete/${complex._id}`, {
      method: "GET",
    });
  };

  return (
    <tr>
      <td>
        {!complex.video && (
          <ToolTip
            id={`exclamation_${complex._id}`}
            body={t("complexLibraryLine.someDataMissing")}
            hintClassNames="new-tooltip"
          >
            <div className="chip danger"></div>
          </ToolTip>
        )}
      </td>
      <td>{getComplexName(complex)}</td>
      <td>
        {complex.video &&
        (complex.video.videoId || complex.video.url !== "") ? (
          <a
            href={`/actions/refresh?modal[type]=exercise-library-video&complex=${complex._id}`}
          >
            <div className="chip video"></div>
          </a>
        ) : null}
      </td>
      <td>
        <div>
          <a
            className="edit-table-action"
            role="button"
            data-button-type="primary"
            data-icon
            href={`/actions/refresh?modal[type]=add-complex&complex=${complex._id}`}
            sz="medium"
          >
            <SvgIcon
              src="/img/new-icons/edit-pencil.svg"
              noFilterOnLight={true}
            />
            {t("complexLibraryLine.edit")}
          </a>

          <button
            role="button"
            data-button-type="text-white"
            data-action="delete"
            data-icon
            onClick={() => setIsModalOpen(true)}
            sz="medium"
          >
            <SvgIcon
              src="/img/new-icons/red-trash.svg"
              noFilterOnLight={true}
              alt="delete movement"
            />
          </button>
          <ConfirmationModal
            isOpen={isModalOpen}
            title={t("complexLibraryLine.deleteComplex")}
            contentText={t("complexLibraryLine.deleteComplexConfirm")}
            cancelButtonText={t("complexLibraryLine.cancel")}
            cancelButtonAction={() => setIsModalOpen(false)}
            confirmButtonText={t("complexLibraryLine.delete")}
            confirmButtonAction={handleDelete}
            icon="delete"
          />
        </div>
      </td>
    </tr>
  );
};

export default ComplexLibraryLine;
